import React from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import PortfolioSection from "./components/PortfolioSection";
import WhyUsSection from "./components/WhyUsSection";
import TestimonialsSection from "./components/TestimonialsSection";
import WorkflowSection from "./components/WorkflowSection";
import PricingSection from "./components/PricingSection";
import FreeAuditSection from "./components/FreeAuditSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <Navigation />
      <HeroSection />
      <StatsSection />
      <PortfolioSection />
      <WhyUsSection />
      <TestimonialsSection />
      <WorkflowSection />
      <PricingSection />
      <FreeAuditSection />
      <FAQSection />
      <ContactSection />
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
